import { Record } from 'immutable';

// Le modèle doit correspondre au DTO backend
const MembreRecord = Record({
  id: '',
  nom: '',
  prenom: '',
  structure: '',
  idStructure: '',
  dateInscription: '',
});

class Membre extends MembreRecord {
  get id() { return this.get('id'); }
  get nom() { return this.get('nom'); }
  get prenom() { return this.get('prenom'); }
  get structure() { return this.get('structure'); }
  get idStructure() { return this.get('idStructure'); }
  get dateInscription() { return this.get('dateInscription'); }

  constructor(props: Partial<{ id: string; nom: string; prenom: string; structure: string; idStructure: string; dateInscription: string }> = {}) {
    super({
      ...props,
      dateInscription: props.dateInscription || '',
    });
  }

  setId(id) { return this.set('id', id); }
  setNom(nom) { return this.set('nom', nom); }
  setPrenom(prenom) { return this.set('prenom', prenom); }
  setStructure(structure) { return this.set('structure', structure); }
  setIdStructure(idStructure) { return this.set('idStructure', idStructure); }
  setDateInscription(dateInscription) { return this.set('dateInscription', dateInscription); }

  // Génère le payload DTO conforme au backend
  toDto() {
    return {
      Nom: this.nom.trim(),
      Prenom: this.prenom.trim(),
      IdStructure: this.idStructure,
      DateInscription: this.dateInscription || new Date().toISOString(),
    };
  }
}

export default Membre;